export const defaultToolbarActions = [
  'create',
  'create_new',
  'save',
  'delete',
  'back',
];

export const toolbar_form_create = {
  type: 'toolbar',
  id: 'toolbar.cmp.create',
  left: ['create'],
  right: ['back'],
};

export const toolbar_form_details = {
  id: 'toolbar.cmp.details',
  type: 'toolbar',
  left: ['save'],
  right: ['delete', 'back'],
};

export const toolbar_form_view = {
  id: 'toolbar.cmp.view',
  type: 'toolbar',
  left: [],
  right: ['back'],
};

export const toolbar_table_list = {
  id: 'toolbar.cmp.index',
  type: 'toolbar',
  left: ['create_new'],
  right: ['back'],
};

export const toolbar_defaults = {
  create: toolbar_form_create,
  edit: toolbar_form_details,
  view: toolbar_form_view,
  index: toolbar_table_list,
};
